module.exports = __webpack_public_path__ + "static/img/13.3c992d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/13.png
// module id = PBG1
// module chunks = 0